import { getColorAlias } from '../../../utils/index.js';

const errorMessage = 'Error, incorrect variant. Use the correct value for variants';
const getBorderColor = (variant) => {
    switch (variant) {
        case 'neutral':
            return getColorAlias('containerInverse');
        case 'info':
            return getColorAlias('supportInfoInverse');
        case 'positive':
            return getColorAlias('supportPositiveInverse');
        case 'warning':
            return getColorAlias('supportWarning');
        case 'error':
            return getColorAlias('supportError');
        default:
            console.warn(errorMessage);
            return '';
    }
};
const getIconFill = (variant) => {
    switch (variant) {
        case 'neutral':
            return getColorAlias('containerDefault');
        case 'info':
            return getColorAlias('supportInfoInverse');
        case 'positive':
            return getColorAlias('supportPositiveInverse');
        case 'warning':
            return getColorAlias('supportWarning');
        case 'error':
            return getColorAlias('supportError');
        default:
            console.warn(errorMessage);
            return '';
    }
};
const getAriaRole = (variant) => {
    switch (variant) {
        case 'info':
        case 'neutral':
        case 'positive':
            return 'status';
        case 'warning':
        case 'error':
            return 'alert';
        default:
            return 'alert';
    }
};

export { getAriaRole, getBorderColor, getIconFill };
